import { useMemo, useRef, useState, forwardRef } from 'react';
import { Image, Group } from 'react-konva';

function ProductImage({ stageRef, src, onLoad, children, isVideo = false }, imageRef) {
  const [position, setPosition] = useState({
    x: stageRef.current?.getWidth() / 2,
    y: stageRef.current?.getHeight() / 2,
  });

  const backgroundImage = useMemo(() => {
    if (isVideo) {
      const video = document.createElement('video');
      video.src = src;
      video.crossOrigin = 'Anonymous';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      const handleLoadedMetadata = () => {
        video.play().catch(e => console.error('Video play error:', e));
        updateMediaDimensions(video);
      };

      video.addEventListener('loadedmetadata', handleLoadedMetadata);
      return video;
    }
    const img = new window.Image();
    img.src = src;
    img.crossOrigin = 'Anonymous';

    img.addEventListener('load', () => {
      updateMediaDimensions(img);
    });
    return img;
  }, [src, isVideo]);

  const updateMediaDimensions = (media) => {
    if (!stageRef.current || !imageRef.current) {
      setTimeout(() => updateMediaDimensions(media), 50);
      return;
    }

    const padding = 0;
    let w = media.videoWidth || media.width;
    let h = media.videoHeight || media.height;
    const targetW = stageRef.current.getWidth() - (2 * padding);
    const targetH = stageRef.current.getHeight() - (2 * padding);
    const widthFit = targetW / w;
    const heightFit = targetH / h;
    const scale = (widthFit > heightFit) ? heightFit : widthFit;

    w = parseInt(w * scale, 10);
    h = parseInt(h * scale, 10);

    imageRef.current.setScale({
      x: scale,
      y: scale,
    });

    setPosition({
      x: (stageRef.current.getWidth() - w) / 2,
      y: (stageRef.current.getHeight() - h) / 2,
    });

    setTimeout(() => {
      onLoad?.();
    });
  };

  return (
    <>
      <Group
        ref={ imageRef }
        x={ position.x }
        y={ position.y }
      >
        <Image
          image={ backgroundImage }
        />
        {children}
      </Group>
    </>
  );
}

export default forwardRef(ProductImage);
